module.exports = "/_next/static/images/0b6ecd46025284666c1cbbea6763237f-izzi-icon.svg";